import React from 'react';
import { Empty } from 'antd';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { getChartColors } from '@/utils/chartColors';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const LanguageAnalytics = ({ dashboardData }) => {
  // Transform API data to match the required format
  const languageData = dashboardData?.field_data?.['Languages spoken']?.map(item => ({
    language: item.language,
    count: item.candidate_count
  })) || [];

  // const generateRandomColor = (numberOfColors) => {
  //   const colors = [];
  //   for (let i = 0; i < numberOfColors; i++) {
  //     // Generate color with minimum brightness to avoid too light colors
  //     const color = '#' + Math.floor(Math.random() * 0x7FFFFF + 0x800000).toString(16);
  //     colors.push(color);
  //   }
  //   return colors;
  // };

  // Transform data for Chart.js
  const chartData = {
    labels: languageData.map(item => item.language),
    datasets: [
      {
        label: 'Number of Candidates',
        data: languageData.map(item => item.count),
        backgroundColor: getChartColors(languageData.length),
        borderColor: getChartColors(languageData.length),
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Candidates: ${context.parsed.y}`;
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Language',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        ticks: {
          maxRotation: 45,
          minRotation: 0
        }
      },
      y: {
        title: {
          display: true,
          text: 'Number of Candidates',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        beginAtZero: true
      }
    }
  };

  return languageData.length > 0 ? (
    <div className="bg-card rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold text-foreground mb-4">Top 10 Spoken Languages Of Candidates</h3>
      <div style={{ height: '400px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  ) : null;
};

export default LanguageAnalytics; 